/**
 *
 * Asynchronously loads the component for BillingPreviewPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BillingPreviewPage = lazyLoad(
  () => import('./index'),
  module => module.BillingPreviewPage,
);
